export function registerPageDrawer(Alpine) {
    Alpine.bind("pageDrawer", () => ({
        ["x-init"]() {
            const openKey = this.$el.dataset.drawerOpenKey;

            if (!openKey) {
                return;
            }

            const panel = () => this.$el.querySelector("[data-page-drawer-panel]");

            const focusPanel = () => {
                const target = panel();

                if (!(target instanceof HTMLElement)) {
                    return;
                }

                const active = document.activeElement;

                if (active instanceof HTMLElement && !target.contains(active)) {
                    active.blur();
                }

                target.focus({ preventScroll: true });
            };

            const onOpenChange = (open) => {
                if (!open) {
                    return;
                }

                focusPanel();
                this.$nextTick(focusPanel);
            };

            if (openKey.startsWith("$wire.")) {
                this.$wire.$watch(openKey.slice("$wire.".length), onOpenChange);
            } else {
                this.$watch(openKey, onOpenChange);
            }
        },
    }));
}
